import { makeAutoObservable } from "mobx";
import { supabase } from "../../utilities/service/SupabaseConnector";
import { dishService } from "./DishService";
import { toastMsg } from "../../utilities/helpers/ToastHelper";
import { storageService } from "../../utilities/service/StorageService";

class DishState{
    constructor(){
        makeAutoObservable(this);
    }
    noteContent: string = '';
    isGettingDishInfoStatus: boolean = true;
    dishListCart: any[] = []
    dishVariantList: any[] = [];
    variantDishMaxPrice: number = 0;
    variantDishMinPrice: number = 1;
    variantChosenID: number = -1;
    variantChosenPrice: number = 0;
    isOpeningNote: boolean = false;
    orderingQuantity: number = 1;
    dishInfo: {id:number, name:string, price:number, img:string, status: boolean, mealType: any[], ingredient: string} = {
        id: 0,
        ingredient: "(Thành phần)",
        name: "(Tên sản phẩm)",
        price: 0,
        img: "",
        status: false,
        mealType: []
    }
    async getDishInfo(id: number, navigate: any){
        this.isGettingDishInfoStatus = true;
        if(isNaN(id)){
            this.isGettingDishInfoStatus = false;
            return -1;
        }
        const mainResponse = await dishService.detailedDishGettingFetching(id);
        const variantResponse = await dishService.variantForDishGettingFetching(id);
        this.isGettingDishInfoStatus = false;
        if(mainResponse.error){
            toastMsg.error(`${mainResponse.error.message}`, '');
        }
        else if(mainResponse.data.length === 0){
            navigate('/not-found')
        }
        else{
            this.dishInfo = mainResponse.data[0];
            this.dishVariantList = variantResponse.data!
            if(this.dishVariantList.length >0){
                this.variantDishMinPrice = this.dishVariantList[0].price
                this.variantDishMaxPrice = this.dishVariantList[0].price
                for(var i in this.dishVariantList){
                    if(this.dishVariantList[i].price > this.variantDishMaxPrice){
                        this.variantDishMaxPrice = this.dishVariantList[i].price;
                    }
                    if(this.dishVariantList[i].price < this.variantDishMinPrice){
                        this.variantDishMinPrice = this.dishVariantList[i].price;
                    }
                }
            }
        }
    }
    async addCartAction(event:any, dishData: any){
        event?.stopPropagation(); //stop clicking from the wrapper tag
        event?.preventDefault(); //stop directing from the wrapper tag;
        toastMsg.success(`Thêm món ${dishData.name} thành công!`, `${dishData.id}`);
        await this.addDishNotLoginAction(dishData, this.orderingQuantity);
    }
    async addDishNotLoginAction(dishData:any, amount: number){
        const dishListFromLocal = storageService.getDishInCart(); //get data from local if it exists
        this.dishListCart = dishListFromLocal ? dishListFromLocal : []; // if local data exists, get it. Otherwise, inititialize another one.
        const existDishInList = this.dishListCart.find((item:any)=>String(item.id) === String(dishData.id)); //if the dish is already in the cart, rise the amount.
        if(existDishInList){
            existDishInList.quantity += amount;
        }
        else{
            this.dishListCart.push({...dishData, quantity: 1, note: this.noteContent})
        }
        storageService.setDishInCart(this.dishListCart);
    }
    async buyNowAction(event:any, dishData: any, navigate: any){
        event?.stopPropagation(); //stop clicking from the wrapper tag
        event?.preventDefault(); //stop directing from the wrapper tag;
        toastMsg.success(`Thêm món ${dishData.name} thành công!`, `${dishData.id}`);
        await this.addDishNotLoginAction(dishData, 1); 
        navigate('/cart')
    }
    async handleVariantBtnAction(id: number){
        if(id !== this.variantChosenID){
            this.variantChosenID = id;
            this.variantChosenPrice = this.dishVariantList.find(dish => dish.id === id).price;
        }
        else{
            this.variantChosenID = -1;
        }
    }
    handleLeaveNoteAction(){
        this.isOpeningNote = !this.isOpeningNote;
    }
    handleQuantityOrderingKeyPress(event:any){
        const regex = /^[0-9]$/; //Only allow number, minus symbol.
        const charCode = event.key
        if(!regex.test(charCode)){
            event.preventDefault();
        }
    }
    handleQuantityOrderingButton(type: string){
        if(type === 'minus'){
            if(this.orderingQuantity <= 1){
                this.orderingQuantity = 1;
                toastMsg.error('Không thể đặt món số lượng ít hơn 1!', ``)
            }
            else{
                this.orderingQuantity -= 1;
            }
        }
        else if(type === 'plus'){
            if(this.orderingQuantity >= 100){
                this.orderingQuantity = 100;
                toastMsg.error('Không thể đặt món số lượng nhiều hơn 100!', ``)
            }
            else{
                this.orderingQuantity += 1;
            }
        }
    }
}
export const dishState = new DishState();